// removed by extract-text-webpack-plugin
module.exports = {"button":"_2IMs3eRp","background":"_1vdXrgHE","show":"_1AM_TCm4","close":"_3TYpTu0c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Lightbox/Lightbox.css
// module id = 98
// module chunks = 0